import {VehicleDriverHistoryExcludeDigitalSignatureTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function excludeTypeFromRequiredDigitalSignatureNameFilter(type?: VehicleDriverHistoryExcludeDigitalSignatureTypeEnum, isTransfer: boolean = false): string {
  const typesToCheck:  VehicleDriverHistoryExcludeDigitalSignatureTypeEnum[] = [ VehicleDriverHistoryExcludeDigitalSignatureTypeEnum.All, isTransfer
    ? VehicleDriverHistoryExcludeDigitalSignatureTypeEnum.Transfer
    : VehicleDriverHistoryExcludeDigitalSignatureTypeEnum.Receive ];


  if (!type || !typesToCheck.includes(type)) return i18n.t(LF.DigitalContract) as string;

  return i18n.t(LF.PaperContract) as string;
}
